import Vue from 'vue';

export default {
  setProcessedValue(input) {
    Vue.set(input, 'shouldTransform', true);
  },

  unsetProcessedValue(input) {
    Vue.set(input, 'shouldTransform', false);
  },
};
